let token = null;
let listeners = [];
let isInitialized = false;
let initializationPromise = null;

export const getToken = () => {
  return token;
};

export const setToken = (newToken) => {
  token = newToken;
  if (newToken) {
    // When setting a new token (e.g., from login), mark as initialized
    isInitialized = true;
  }
  notifyListeners();
};

export const clearToken = () => {
  token = null;
  // Use safe notification for clear token as well
  listeners.forEach((listener) => {
    try {
      listener(null);
    } catch (error) {
      console.error('Error in token listener during clear:', error);
    }
  });
};

export const logout = () => {
  const oldToken = token;
  token = null;
  isInitialized = false;
  initializationPromise = null;

  // Notify listeners with explicit null to prevent decode attempts
  listeners.forEach((listener) => {
    try {
      listener(null);
    } catch (error) {
      console.error('Error in token listener during logout:', error);
    }
  });
};

export const subscribe = (listener) => {
  listeners.push(listener);
  // Return unsubscribe function
  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
};

export const isTokenInitialized = () => {
  return isInitialized;
};

export const setInitialized = (initialized) => {
  isInitialized = initialized;
};

export const getInitializationPromise = () => {
  return initializationPromise;
};

export const setInitializationPromise = (promise) => {
  initializationPromise = promise;
};

const notifyListeners = () => {
  listeners.forEach((listener) => listener(token));
};
